import React, { useEffect, useRef } from 'react';

import * as UTIF from 'utif';

const TiffPage = ({ page, index }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !page) return;

    const renderPage = async () => {
      try {
        if (page.isBlob || page.isPng) {
          canvas.width = page.width;
          canvas.height = page.height;

          const img = new Image();
          img.onload = () => {
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
          };
          img.src = page.imageUrl;
          return;
        }

        // Handle TIFF pages
        const rgba = UTIF.toRGBA8(page);
        let width, height;

        if (page['256'] && Array.isArray(page['256'])) {
          width = page['256'][0];
        } else if (page.t256 && Array.isArray(page.t256)) {
          width = page.t256[0];
        } else if (page.width) {
          width = page.width;
        }

        if (page['257'] && Array.isArray(page['257'])) {
          height = page['257'][0];
        } else if (page.t257 && Array.isArray(page.t257)) {
          height = page.t257[0];
        } else if (page.height) {
          height = page.height;
        }

        if (!width || !height) {
          const commonWidths = [1728, 2048, 1024, 2480, 3508];
          for (const w of commonWidths) {
            const h = rgba.length / (w * 4);
            if (Number.isInteger(h) && h > 0) {
              width = w;
              height = h;
              break;
            }
          }
        }

        if (width && height && width > 0 && height > 0) {
          canvas.width = width;
          canvas.height = height;
          const imageData = new ImageData(new Uint8ClampedArray(rgba), width, height);
          const ctx = canvas.getContext('2d');
          ctx.putImageData(imageData, 0, 0);
        }
      } catch (error) {
        // Silent error
      }
    };

    renderPage();
  }, [page]);

  return (
    <canvas
      ref={canvasRef}
      className="max-w-full"
      style={{ height: 'auto' }}
      data-page-index={index}
    />
  );
};

export default TiffPage;
